  import { Characteristics } from "../Characteristics";
import {
  Advance,
  Equipment,
  FighterInjury,
  LevelUp,
  Skill,
  Status,
  WeaponUpgrade,
} from "../Types";

export class Fighter {
  id!: string;
  factionId!: string;
  teamId!: string;
  isDead!: boolean;
  availableForEdit!: boolean;
  name!: string;
  rang!: string;
  description!: string;
  notes!: string;
  totalCost!: number;
  userCostModifier!: number;
  xp!: number;
  lvl!: number;
  status!: Status | null;
  baseCharacteristics!: Characteristics;
  totalCharacteristics!: Characteristics;
  totalInjuriesCharacteristics!: Characteristics;
  totalAdvancesCharacteristics!: Characteristics;
  userCharacteristicsDtoModifiers!: Characteristics;
  userRatingModificator!: number;
  injuries!: FighterInjury[];
  levelUps!: LevelUp[];
  weapons!: FighterWeapon[];
  equipment!: Equipment[];
  skills!: Skill[];
  commandHistory!: CommandHistory[];
  //specialRules!: SpecialRule[];
}

export type FighterWeapon = {
  id: string;
  fighterWeaponId: string;
  description: string;
  name: string;
  cost: number;
  upgrades: WeaponUpgrade[];
  totalCost: number;
};

export type CommandHistory =
  {
    id: string;
    createdAt: Date;
    description: string;
  }

export type EditFighterCharacteristicsDto = {
  userCharacteristicModifications: Characteristics;
  userRatingModificator: number;
}